import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { SupplierScheduleViewComponent } from './supplier-schedule-view.component';
import { TableModule } from 'primeng';

const routes: Routes = [
  { path: '', component: SupplierScheduleViewComponent, data: { title: 'Supplier Schedule View' } },
  {
    path: ':id',
    component: SupplierScheduleViewComponent,
    data: { title: 'Supplier Schedule View' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierScheduleViewRoutingModule {}

@NgModule({
  imports: [
    SupplierScheduleViewRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [SupplierScheduleViewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SupplierScheduleViewModule {}
